import apiClient from "./apiClient";

const url = "https://api.adsign.adactive.asia";
// const url = 'http://localhost:5000';

const getIpAddress = async () => {
  const res = await fetch("https://api.ipify.org/?format=json", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  console.log(res.data);
  return res.data.ip;
};

export const auth = async (email, password) => {
  try {
    // const ipAddress = await getIpAddress();
    const response = await fetch(`${url}/auth/signin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password, ipAddress: "127.0.0.1" }),
    });

    if (!response.ok) {
      throw new Error("Authentication failed");
    }

    const data = await response.json();

    localStorage.setItem("authToken", data.accessToken);
    localStorage.setItem("user", JSON.stringify(data));
    return data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
};

export const updateTicketStatus = async (ticketId, status, activity) => {
  const ticketData = {
    id: ticketId,
    status: status,
    activity: activity,
  };

  const token = localStorage.getItem("token");

  console.log("Updating ticket status:", ticketData);

  try {
    const response = await fetch(`${url}/ticket`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ticketData }),
    });

    if (!response.ok) {
      throw new Error("Failed to create ticket");
    }

    const data = await response.json();
    console.log("Ticket updated successfully:", data);
    return data;
  } catch (error) {
    console.error("Error creating ticket:", error);
    throw error;
  }
};

export const createNewTicket = async (ticketData) => {
  let ticket;
  let token;
  try {
    const email = "webrtc@adactive.asia";
    const password = "Secret123456!";
    token = await auth(email, password);
    const accessToken = token.accessToken;
    localStorage.setItem("token", accessToken);
  } catch (validationError) {
    console.error("Ticket data validation error:", validationError);
    throw validationError;
  }
  console.log("Token:", token);

  try {
    const response = await fetch(`${url}/ticket`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token.accessToken}`,
      },
      body: JSON.stringify(ticketData),
    });

    if (!response.ok) {
      throw new Error("Failed to create ticket");
    }

    const data = await response.json();
    ticket = data;
    return ticket;
  } catch (error) {
    console.error("Error creating ticket:", error);
    throw error;
  }
};
